module.exports = __webpack_public_path__ + "static/media/chorthippus_mollis.dac68ac7.jpg";